import { Ghost } from "@ui/Ghost";
import { MaterialSymbol } from "@ui/MaterialSymbol";
import { HStack } from "@ui/Stack";
import { Text } from "@ui/typography/Text";
import { Show } from "solid-js";
import { formatCredits } from "./formatters";

type Props = {
	totalCredits: number;
	chatThinking: boolean;
};

export const ChatUsageStat = (props: Props) => (
	<div class="cost-dropdown__stat">
		<Text
			as="span"
			family="mono"
			size="xsmall"
			weight="bold"
			color="fg3"
			transform="uppercase"
			style={{
				display: "block",
				"margin-bottom": "0.375rem",
			}}
		>
			Usage
		</Text>
		<HStack spacing="medium" align="center">
			<MaterialSymbol
				symbol="toll"
				color="primary"
				relativeSize="even-larger"
			/>
			<Show
				when={!props.chatThinking}
				fallback={<Ghost width="2.5rem" height="1.5rem" />}
			>
				<Text size="xlarge" weight="extra-bold" color="ink" family="display">
					{formatCredits(props.totalCredits)}
				</Text>
			</Show>
		</HStack>
		<Text
			as="span"
			size="xsmall"
			color="fg3"
			style={{ display: "block", "margin-top": "0.375rem" }}
		>
			credits used in this chat
		</Text>
	</div>
);
